import { render, staticRenderFns } from "./AdminGalleryCard.vue?vue&type=template&id=0689484e"
import script from "./AdminGalleryCard.vue?vue&type=script&lang=js"
export * from "./AdminGalleryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports